import React from "react";
import { Button, Paper, Typography } from "@material-ui/core";
import { useOnlineStatus } from "../hooks/useOnlineStatus";

// Fallback for the root ErrorBoundary; without it a render crash left a blank dark screen.
export const AppErrorFallback: React.FC<{
  error: Error;
  eventId: string | null;
}> = ({ error, eventId }) => {
  const isOnline = useOnlineStatus();
  return (
    <div className="flex justify-center px-4 pt-12 pb-4">
      <Paper className="w-full max-w-md p-6 flex flex-col gap-4">
        <Typography variant="h6">Something went wrong</Typography>
        <Typography variant="body2">
          The app hit an unexpected error. Reloading usually fixes it. If it keeps happening, send the details below to
          support.
        </Typography>
        <Typography variant="caption" component="pre" className="whitespace-pre-wrap break-words">
          {error?.message || String(error)}
          {eventId ? `\nReference: ${eventId}` : ""}
        </Typography>
        {!isOnline && (
          <Typography variant="body2" color="error">
            This phone is offline. Reconnect before reloading.
          </Typography>
        )}
        <Button
          size={"large"}
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
          className="w-full"
        >
          Reload
        </Button>
      </Paper>
    </div>
  );
};
